"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8646],{

/***/ 58646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M14.4 7H21c.6 0 1 .4 1 1s-.4 1-1 1h-6.6l2.3 2.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4-4c-.05-.05-.075-.1-.1-.15-.025-.05-.05-.1-.1-.15-.1-.3-.1-.5 0-.8 0-.1.1-.2.2-.3l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L14.4 7zm-1.6 8.45c.025.05.05.1.1.15.1.3.1.5 0 .8 0 .1-.1.2-.2.3l-4 4c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L9.6 17H3c-.6 0-1-.4-1-1s.4-1 1-1h6.6l-2.3-2.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4 4c.05.05.075.1.1.15z"
}), "CurrencyExchange"));


/***/ })

}]);